export default {
    logout: 'Logout',
    connection_status: 'Connection status',
    group_id: 'Group Id',
    song_id: 'Song Id',
    waiting_for_song_to_play: 'Waiting for song to play',
    waiting_for_next_music: 'Waiting for next music',
    song_name: 'Song name',
    artist_name: 'Artist name',
    movie_name: 'Movie name',
    enter_group_id: 'Enter group id',
    login: 'Login',
    score: 'Score',
    release: 'Release',
    artist: 'Artist',
    language: 'Language',
    points: 'Points',
    bonus: 'Bonus',
    movie: 'Movie',
    answer_saved: 'Answer saved',
    correct: 'Correct',
    wrong: 'Wrong',
    password: 'Password',
    error: 'Error',
    invalid_password: 'Invalid password',
    group: 'Group',
    connecting: 'Connecting',
    connected: 'Connected',
    disconnected: 'Disconnected',
    points_obtained: 'Points obtained',
    total_points: 'Total points',
    title: 'Title',
    id: 'ID',
    failed: 'Failed',
    lost: 'Lost',
    no_group_id: 'No group id found',
    set_my_group_id_now: 'Set my group id now',
    rank: 'Rank',
    global_rank: 'Global Rank',
    category_rank: 'Category Rank',
    leaderboard: 'Leaderboard',
}